module.exports = __webpack_public_path__ + "img/wechatQRCode_01.5564e72c.png";